export default {"src":"__ASTRO_ASSET_IMAGE__g50k1DIN__","width":48,"height":48,"format":"svg"}